import React, { useEffect, useState } from 'react';

function isoToBR(iso) {
  const m = String(iso || '').match(/^(\d{4})-(\d{2})/);
  return m ? `${m[2]}/${m[1]}` : '';
}
function brToIso(br) {
  const m = String(br).match(/^(\d{2})\/(\d{4})$/);
  if (!m) return null;
  const mm = parseInt(m[1]); const yyyy = parseInt(m[2]);
  if (mm < 1 || mm > 12 || yyyy < 1900) return null;
  return `${yyyy}-${String(mm).padStart(2,'0')}`;
}
function mask(raw) {
  const d = raw.replace(/\D/g, '').slice(0, 6);
  if (d.length <= 2) return d;
  return d.slice(0,2) + '/' + d.slice(2);
}

export default function MonthInput({ value, onChange, placeholder = 'mm/aaaa', className = '' }) {
  const [text, setText] = useState(isoToBR(value));
  useEffect(() => { setText(isoToBR(value)); }, [value]);

  const commit = (br) => {
    setText(br);
    const iso = brToIso(br);
    if (iso) onChange?.(iso);
    else if (!br) onChange?.('');
  };

  return (
    <input
      type="text"
      inputMode="numeric"
      value={text}
      onChange={(e) => commit(mask(e.target.value))}
      placeholder={placeholder}
      className={`input-md ${className}`}
    />
  );
}
